export default __webpack_public_path__ + "static/media/drive-thumbnail.ef1266e9.png";